import { r as registerPlugin } from '../common/index-67482630.js';
import '../common/_polyfill-node:global-acbc543a.js';

const App = registerPlugin('App', {
    web: () => import('../common/web-aeb45d0b.js').then(m => new m.AppWeb()),
});

export { App };
